import React from 'react';

const defaultContext = {
  isAVehicle() { return false; },
  isALargeEquipment() { return false; },
  isHoistingLicenseRequired() { return false; }
};

const ToolContext = React.createContext(defaultContext);

export {
  defaultContext,
  ToolContext
};
